import React from 'react';
import { Space, TableProps } from 'antd';
import TableComponent from '../table';
import { IProduct } from '../../interfaces/product';

interface IProps {
  product: IProduct[];
}

const ProductTableDetail = ({ product }: IProps) => {
  const columns: TableProps<IProduct>['columns'] = [
    {
      sorter: true,
      title: 'รหัส',
      dataIndex: 'code',
      key: 'code',
      className: 'font-bold',
      width: 120,
    },
    {
      sorter: true,
      title: 'สินค้า',
      dataIndex: 'name',
      key: 'name',
      className: 'font-bold',
    },
    {
      sorter: true,
      title: 'ราคาขาย',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      className: 'font-bold text-blue-600',
      align: 'right',
      render: (_, rec) => (
        <Space>
          {rec?.unitPrice?.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Space>
      ),
    },
    {
      title: 'หน่วย Package',
      dataIndex: 'packageUnitName',
      key: 'packageUnitName',
      width: 120,
    },
    {
      title: 'Conversion',
      dataIndex: 'conversion',
      key: 'conversion',
      className: 'font-bold',
      align: 'right',
      width: 120,
      render: _ => (
        <Space>
          {(_ || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Space>
      ),
    },
    {
      title: 'หน่วยขาย',
      dataIndex: 'baseUnitName',
      key: 'baseUnitName',
      width: 120,
    },
  ];

  return (
    <TableComponent<IProduct>
      columns={columns}
      criteria={undefined}
      data={{ data: product || [], totalRecords: product?.length || 0 }}
      loading={false}
      onTableChange={undefined}
      scroll={false}
    />
  );
};

export default ProductTableDetail;
